import React from "react";
import PropTypes from "prop-types";
import {
  Dimmer,
  Transition,
  Container,
  Segment,
  Icon,
  Header
} from "semantic-ui-react";
import AddContactosForm from "./addContactos/AddContactosForm";

const AddContactos = ({ closeDialog, show, onChange }) => {
  const cancelModal = () => closeDialog(!show);

  return (
    <Transition unmountOnHide visible={show} animation="scale" duration={200}>
      <Dimmer page active={show}>
        <Container text>
          <Segment>
            <Header as="h2" color="pink">
              <Icon name="university" />
              <Header.Content>Nuevo Contacto</Header.Content>
            </Header>
            <AddContactosForm cancelModal={cancelModal} saveModal={onChange} />
          </Segment>
        </Container>
      </Dimmer>
    </Transition>
  );
};

AddContactos.propTypes = {
  show: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}

AddContactos.defaultProps = {
  show: true
}

export default AddContactos;



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/colegioForm/contactosTabla/AddContactos.jsx